/**
 * Mac vs. everything-else detection for the command palette's shortcut —
 * ⌘K on Mac, Ctrl K elsewhere. `navigator.platform` is deprecated but still
 * the simplest reliable signal (`userAgentData` isn't available in Safari);
 * SSR/test environments without `navigator` fall back to non-Mac.
 */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return navigator.platform.toUpperCase().includes('MAC');
}

/** Display hint for the sidebar's search trigger and similar affordances. */
export function commandPaletteShortcutHint(): string {
  return isMacPlatform() ? '⌘K' : 'Ctrl K';
}
